import { LoadingButton } from "@mui/lab";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { RuleFactoryType, TabKeys } from "@repo/server-api/types";
import { useTranslation } from "next-i18next";
import React, { useMemo } from "react";

import Tabs from "../Tabs";

export default function DialogWithTabs(
	props: Readonly<{
		open: boolean;
		handleClose: () => void;
		handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
		title: string;
		tabs: { label: string; key: TabKeys; content: React.ReactNode }[];
		value: number;
		setValue: (value: number) => void;
		errors?: Record<string, boolean | object | string>;
		saveClicked: boolean;
		ruleFactory: RuleFactoryType;
		testId?: string;
	}>,
) {
	const { t } = useTranslation();

	const open = useMemo(() => props.open, [props.open]);

	const handleClose = () => {
		props.handleClose();
	};

	const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		props.handleSubmit(event);
	};

	return (
		<Dialog
			open={open}
			PaperProps={{
				component: "form",
				onSubmit: handleSubmit,
			}}
			maxWidth="lg"
			fullWidth={true}
			data-testid={props.testId}
		>
			<DialogTitle>{props.title}</DialogTitle>
			<DialogContent>
				<Tabs
					errors={props.errors as Record<string, string>}
					tabs={props.tabs}
					tabIndex={props.value}
					setTabIndex={props.setValue}
					rulefactory={props.ruleFactory}
				/>
			</DialogContent>
			<DialogActions>
				<Button
					data-testid="close-button"
					variant="outlined"
					onClick={handleClose}
				>
					{t("cancel")}
				</Button>
				<LoadingButton
					loading={props.saveClicked}
					className={props.saveClicked ? "" : "blueButton"}
					variant="contained"
					type="submit"
					data-testid="save-button"
				>
					{t("save")}
				</LoadingButton>
			</DialogActions>
		</Dialog>
	);
}
